import { translate } from '../../../common/utility/DisplayPrep';
const { READ_ONLY_FEATURES } = process.env;

const actions = READ_ONLY_FEATURES === 'true' ? ['edit'] : ['edit', 'delete'];

export const defaultUiConfig = {
    name: 'Schemes',
    withActions: actions,
    primaryKey: 'schemeId',
    pageSize: 10,
    properties: {
        schemeId: {
            name: 'Scheme Id',
            rowDisplay: false,
            sortable: true,
            input: (v) => {
                return typeof v.schemeId !== 'undefined' ? 'valueDisplay' : null;
            }
        },
        schemeName: {
            name: 'Scheme Name',
            rowDisplay: true,
            sortable: true,
            input: 'text'
        },
        description: {
            name: 'Description',
            rowDisplay: true,
            sortable: true,
            input: 'multiline'
        },
        securityPermissions: {
            name: 'Security Permissions',
            rowDisplay: false,
            sortable: true
        },
        lastModId: {
            rowDisplay: false,
            name: 'Last Modified ID'
        },
        lastModDatetime: {
            rowDisplay: false,
            displayPrep: 'FullDate',
            name: 'Last Modified Datetime',
            additionalProperties: {
                Cell: ({ cell: { value } }) => {
                    return translate.ReadableDateTimeColumn(value);
                }
            }
        },
        createId: {
            rowDisplay: false,
            name: 'Create ID'
        },
        createDatetime: {
            rowDisplay: false,
            name: 'Create Datetime'
        }
    },
    newDoc: {
        schemeName: null,
        description: null,
        securityPermissions: [],
        createDatetime: null,
        createId: null,
        dtoState: 'NEW',
        lastModDatetime: null,
        lastModId: null
    }
};

export default defaultUiConfig;
